<template>
  <div class="recharge-details">
    <div class="breadcrumb" style="background: #fff">平台折扣</div>
    <div class="order-detail-basic">
      <el-form :model="storeInfo" ref="numberValidateForm" label-width="100px">
        <!-- <el-form-item label="平台号：">
              <span>{{ storeInfo.code }}</span>
            </el-form-item>
            <el-form-item label="平台名称：">
              <span>{{ storeInfo.name }}</span>
            </el-form-item> -->
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect" :disabled="disabled">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round v-if="!disabled">验证平台</el-button>
          <span v-show="show || $route.query.id">平台名称:{{ storeName }}</span>
        </el-form-item>
        <!-- <el-form-item label="充值余额：">
          <span>{{ myBalance }}</span>
        </el-form-item> -->
        <el-form-item label="申请折扣：">
          <el-input v-model="storeInfo.applyDiscount" :disabled="disabled" @input="handleInput"></el-input>
          <div>此处输入折扣（如：1.1;1.2）,后台会按照设置计算该平台的基础P价格</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="submitRecharge()" v-if="!$route.query.id">确认申请</el-button>
      <el-button round type="primary" @click="submitEdit()" v-if="$route.query.type == 3">确认</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)" v-if="$route.query.type == 1">返回</el-button>
      <el-button round style="width: 100px" @click="checkType = false, checkDialog = true" v-preventReClick v-if="$route.query.type == 2">审核拒绝</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="checkType = true, checkDialog = true" v-preventReClick v-if="$route.query.type == 2">审核通过</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <div>{{ checkType ? '是否确认审核通过？' : '是否确认审核拒绝？' }}</div>
      <el-input v-if="!checkType" v-model="storeInfo.rejectReason" placeholder="请输入原因" style="margin-top: 15px;" type="textarea"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <CombinedDialog ref="combinedRef"></CombinedDialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { storeQueryListByCode, storeQueryByStoreCode, membership, applyDiscountAudit, applyDiscountUpdate, applyDiscount } from '@/api/crm'
import { getByStoreIds } from '@/api/epay'
export default {
  name: 'recharge',
  components: {
    CombinedDialog
  },
  data () {
    return {
      disabled: false,
      checkDialog: false,
      checkType: false,
      show: false,
      code: this.$route.query.code || '', // 平台号
      storeName: this.$route.query.storeName || '',
      type: 'amount', // 充值类型
      storeInfo: {
        storeId: this.$route.query.storeId || null,
        applyDiscount: this.$route.query.applyDiscount || ''
      },
      amount: null,
      remark: '',
      storeId: this.$route.query.storeId || null,
      chargeLine: '',
      myBalance: ''
    }
  },
  created () {
    if (this.$route.query.id && this.$route.query.type != 3) {
      this.disabled = true
    } else {
      this.disabled = false
    }
  },
  watch: {
    code () {
      this.show = false
    }
  },
  methods: {
    handleInput (value) {
      // 只允许数字和最多两位小数
      this.storeInfo.applyDiscount = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')
      // 限制小数点后最多两位数
      if (this.storeInfo.applyDiscount.indexOf('.') > -1) {
        const parts = this.storeInfo.applyDiscount.split('.')
        if (parts[1].length > 2) {
          this.storeInfo.applyDiscount = parts[0] + '.' + parts[1].slice(0, 2)
        }
      }
    },
    querySearchAsync (queryString, cb) {
      let val = queryString.replace(/\s*/g, '')
      if (!val) {
        return
      }
      storeQueryListByCode(val).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    // 验证平台
    async verifyStore () {
      this.code = this.code.replace(/\s*/g, '')
      if (!this.code) {
        this.$message.error('请输入平台号')
        return
      }
      await storeQueryByStoreCode(this.code).then(async res => {
        if (res.data.data.exist) {
          this.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
          await getByStoreIds(this.storeId).then((res) => {
            if (res.data.success) {
              this.myBalance = res.data.data?.balances.ACCT?.balance // 充值余额
            } else {
              this.myBalance = ''
            }
          })
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    handleSelect (item) {
      this.storeInfo.storeId = item.id
    },
    // getConfig () {
    //   adminConfigGet('WARNING_LINE_CHARGE').then(res => {
    //     if (res.data.success) {
    //       this.chargeLine = res.data.data.value
    //     }
    //   })
    // },
    // 确认申请
    submitRecharge () {
      console.log(111)
      if (!this.storeInfo.storeId) {
        this.$message.error('请输入平台号')
        return
      }
      if (!this.storeInfo.applyDiscount) {
        this.$message.error('请输入申请折扣')
        return
      }
      if (this.storeInfo.applyDiscount < 0) {
        this.$message.error('折扣价格不能小于0')
        return
      }
      applyDiscount(this.storeInfo).then(res => {
        console.log(res)
        if (res.data.success) {
          // this.$router.push({
          //   path: '/reviewDiscount'
          // })
          this.$router.go(-1)
        }
      })
    },
    // 确认编辑
    submitEdit () {
      this.storeInfo.id = this.$route.query.id
      applyDiscountUpdate(this.storeInfo).then(res => {
        if (res.data.success) {
          this.$message.success('编辑成功')
          this.$router.go(-1)
        }
      })
    },
    // 审核
    check () {
      if (!this.checkType && !this.storeInfo.rejectReason) {
        this.$message.error('请输入拒绝原因')
        return
      }
      this.storeInfo.id = this.$route.query.id
      this.storeInfo.status = this.checkType ? 1 : 2
      applyDiscountAudit(this.storeInfo).then(res => {
        if (res.data.success) {
          this.$message.success('审核成功')
          this.checkDialog = false
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~'>>>';

.recharge-details {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
